function filter_ingredients(phrase) {
    var close_icon = $('#filter_ingredients').siblings('.search__close');
    var loading_icon = $('#filter_ingredients').siblings('.search__loading');

    //If phrase is cleared/empty, hide X icon and show all
    if(phrase === '') {
        close_icon.hide();
        loading_icon.show();
        setTimeout(function() {
            $('.stocktake-ingredient-row.visible').removeClass('filtered');
            loading_icon.hide();
        }, 0);
        return true;
    }

    //Show loading icon
    loading_icon.show();

    setTimeout(function() {

        //Loop over our ingredient rows...
        $.each($('.stocktake-ingredient-row.visible'), function(i, v) {

            //Get ingredient name from dropdown
            var selected_ingredient = $.trim($(this).find('select[name="ingredient_id_select[]"] option:selected').html());

            //If this ingredient matches phrase, show it
            var match = selected_ingredient.search(new RegExp(phrase, 'i'));
            if(match !== -1) {
                $(this).removeClass('filtered');

                //Otherwise hide it
            } else {
                $(this).addClass('filtered');
            }

        });

        //Show X icon
        loading_icon.hide();
        close_icon.show();

    }, 0);

}

function add_stocktake_ingredient_row() {
    var $container = $('.stocktake-container');
    var $cloneable = $container.find('.cloneable');

    //Clone cloneable measurement row and append to container
    var $row = $cloneable.clone();
    $row.removeClass('cloneable').addClass('visible');
    $row.find('input[disabled], select[disabled]').removeAttr('disabled');
    $row.find('.no-touchy').removeClass('no-touchy');

    //Disable wastage/unit when cloning new row
    $row.find('select[name="ingredient_wastage_id[]"]').attr('disabled', 'disabled');
    $row.find('select[name="ingredient_unit[]"]').attr('disabled', 'disabled');

    $row.appendTo($container);

    $('.stocktake-ingredient-hint').hide();

    init_selects();

    return $row;
}

$(function() {

    //Show filter ingredients field on DOM ready
    $('.search__field').show();

    //Disable Enter keypress on filter field
    $body.on('keyup keypress', '#filter_ingredients', function(e) {

        //If they hit Enter on this field, run our filtering but halt form submission
        if(e.which === 13) {
            filter_ingredients($(this).val());
            return false;
        }

        return true;
    });

    //Remove all filters when X icon clicked
    $body.on('click', '.search__close', function(e) {
        e.preventDefault();
        $('#filter_ingredients').val('');
        filter_ingredients('');
    });

    $body.on('click', '#add-stocktake-ingredient-row', function(e) {
        e.preventDefault();
        add_stocktake_ingredient_row();
    });

    $body.on('click', '#add-stocktake-ingredient-row-5', function(e) {
        e.preventDefault();

        for(var i = 0; i < 5; i++) {
            add_stocktake_ingredient_row();
        }
    });

    //Change ingredient selected on Stocktake form
    $('#edit-stocktake-form').on('change', 'select[name="ingredient_id_select[]"]', function(e) {
        var $row = $(this).closest('.row');
        var $ing_type = $row.find('select[name="ingredient_wastage_id[]"]');
        var $ing_unit = $row.find('select[name="ingredient_unit[]"]');
        var ing_type_prev = $ing_type.attr('data-prev-value');
        var ing_unit_prev = $ing_unit.attr('data-prev-value');

        //Set data
        var ing_id = $(this).val();
        var $selected_ing = $(this).find('option:selected');

        //Disable ing type and unit selects
        $ing_type.attr('disabled', 'disabled').trigger('chosen:updated');
        $ing_unit.attr('disabled', 'disabled').trigger('chosen:updated');

        if($selected_ing.data('context') === 'ingredient') {

            //Set id to hidden field
            $row.find('input[name="ingredient_id[]"]').val(ing_id);
            $row.find('input[name="ingredient_id_recipe[]"]').val('-1');

            //Set id to edit button (if has one)
            $row.find('.edit-stocktake-ing').data('id', ing_id).show();

            //Get ing/rcp fields
            var $ing_fields = $row.find('.toggle-type[data-context="ingredient"]');
            var $rcp_fields = $row.find('.toggle-type[data-context="recipe"]');

            //Set ing fields to enabled
            $ing_fields.find('input, select, textarea').removeAttr('disabled');

            //Set rcp fields to disabled
            $rcp_fields.find('input, select, textarea').attr('disabled', 'disabled');

            //Show/hide them
            $ing_fields.show();
            $rcp_fields.hide();

            //Get wastages for selected ingredient
            get_wastages_for_ingredient(ing_id, function(resp) {

                //If successful...
                if(resp.response) {

                    //Replace the wastage select with our new one
                    $ing_type.parent().html(resp.content);

                } else {
                    alert(resp.message);
                }

                //Need to reinit selects when both are done
                init_selects();

            }, ing_type_prev);

            //Get units for selected ingredient
            get_units_for_ingredient(ing_id, function(resp) {

                //If successful...
                if(resp.response) {

                    //Replace the unit select with our new one
                    $ing_unit.parent().html(resp.content);

                } else {
                    alert(resp.message);
                }

                //Need to reinit selects when both are done
                init_selects();

            }, ing_unit_prev);

        } else if($selected_ing.data('context') === 'recipe')  {

            //Set id to hidden field
            $row.find('input[name="ingredient_id_recipe[]"]').val(ing_id);
            $row.find('input[name="ingredient_id[]"]').val('-1');

            //Hide edit button for this one
            $row.find('.edit-stocktake-ing').data('id', '').hide();

            //Get ing/rcp fields
            var $ing_fields = $row.find('.toggle-type[data-context="ingredient"]');
            var $rcp_fields = $row.find('.toggle-type[data-context="recipe"]');

            //Set ing fields to disabled
            $ing_fields.find('input, select, textarea').attr('disabled', 'disabled');

            //Set rcp fields to enabled
            $rcp_fields.find('input, select, textarea').removeAttr('disabled');

            //Show/hide them
            $ing_fields.hide();
            $rcp_fields.show();

            //Get units for selected recipe
            get_units_for_recipe(ing_id, function(resp) {

                //If successful...
                if(resp.response) {

                    //Replace the unit select with our new one
                    $ing_unit.parent().html(resp.content);

                } else {
                    alert(resp.message);
                }

                //Reset wastages dropdown (remove all options)
                $ing_type.find('option[value!="-1"]').remove();
                $ing_type.val('-1').removeAttr('disabled').trigger('chosen:updated');

                //Need to reinit selects when both are done
                init_selects();

            }, 'ingredient_unit[]');
        }

    });

    //Change ingredient quantity/unit on stocktake form
    $('#edit-stocktake-form').on('change', 'select[name="ingredient_id_select[]"], select[name="ingredient_wastage_id[]"], input[name="ingredient_quantity[]"], select[name="ingredient_unit[]"]', function(e) {
        var $row = $(this).closest('.stocktake-ingredient-row');
        var $ingredients = $row.find('select[name="ingredient_id_select[]"] option');
        var $wastages = $row.find('select[name="ingredient_wastage_id[]"] option');
        var $units = $row.find('select[name="ingredient_unit[]"] option');
        var $selected_ing = [];
        var $selected_wastage = [];
        var $selected_unit = [];

        //Get selected ingredient
        $.each($ingredients, function(i, v) {
            if($(this).prop('selected')) {
                $selected_ing = $(this);
            }
        });

        //Get selected wastage
        $.each($wastages, function(i, v) {
            if($(this).prop('selected')) {
                $selected_wastage = $(this);
            }
        });

        //Get selected units
        $.each($units, function(i, v) {
            if($(this).prop('selected')) {
                $selected_unit = $(this);
            }
        });

        //If we have selected an ingredient...
        if($selected_ing.length > 0) {

            var source_quantity = $selected_ing.data('quantity');
            var source_unit = $selected_ing.data('unit');
            var source_price = $selected_wastage.data('price') ? $selected_wastage.data('price') : $selected_ing.data('price');
            var $target_quantity = $row.find('input[name="ingredient_quantity[]"]');
            var target_quantity = $target_quantity.val();

            //Convert any "custom" unit metrics into their proper values for calcing
            var custom_quantity = $selected_unit.data('custom-quantity') ? parseFloat($selected_unit.data('custom-quantity')) : 1;
            var new_quantity = (parseFloat($selected_unit.data('quantity')) * parseFloat(target_quantity)) / custom_quantity;
            var new_unit = $selected_unit.data('unit');

            var $price = $row.find('.ingredient-price');

            //Ensure all needed fields are here before calculating price
            if(source_quantity && source_unit && source_price && Number.isFinite(new_quantity) && new_unit) {

                //Set loading on price
                $price.html("...");

                //Load in the ingredient wastages
                ajax_call('get', '/admin/get_price/' + source_quantity + '/' + source_unit + '/' + new_quantity + '/' + new_unit + '/' + source_price, {}, function(resp) {

                    //If successful...
                    if(resp.response) {

                        //Replace the wastage select with our new one
                        $price.html(resp.content);

                    } else {
                        alert(resp.message);
                    }
                });
            } else {
                console.log('At least one value missing - cannot calc price.');
            }

        }

    });


});
